import * as React from "react";
import {
  ImageField,
  TextInput,
  ImageInput,
  BooleanInput,
  Edit,
  FormDataConsumer,
  NumberInput,
  useRecordContext,
  Title,
} from "react-admin";
import { SimpleForm } from "../common/SimpleForm";
import { IMAGE_MAX_SIZE } from "../constants/FileConstants";
import { validateOrderOptional, validateRequired } from "../utils/Validations";

const DistrictTitle = () => {
  const record = useRecordContext();
  return <Title title={`Barrio "${record?.name}"`} />;
};

const DistrictEdit = () => (
  <Edit title={<DistrictTitle />} mutationMode="pessimistic" redirect="list">
    <SimpleForm>
      <TextInput source="name" label="Nombre" validate={validateRequired} />
      <ImageInput
        source="image"
        label="Imagen"
        accept={{
          "image/*": [],
        }}
        maxSize={IMAGE_MAX_SIZE}
      >
        <ImageField source="src" title="title" />
      </ImageInput>
      <FormDataConsumer>
        {({ formData, ...rest }) => {
          if (!formData?.image?.rawFile) {
            return <ImageField source="image" {...rest} />;
          }
        }}
      </FormDataConsumer>
      <NumberInput
        source="order"
        label="Orden"
        min={1}
        validate={validateOrderOptional}
        onWheel={(e) => e.target.blur()}
      />
      <BooleanInput source="visible" label="Visible" />
      <BooleanInput source="active" label="Activo" />
    </SimpleForm>
  </Edit>
);

export default DistrictEdit;
